import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import "./blockchain-admin-ui.css";

const GAME_MODES = [
    {
        id: "xd45s",
        label: "Xóc đĩa 45 giây (6 Sảnh)",
        path: "/admin/setxd45s",
        tablesCount: 6,
        tableLetters: ["A", "B", "C", "D", "E", "F"]
    },
    {
        id: "xd60s",
        label: "Xóc đĩa 60 giây (6 Sảnh)",
        path: "/admin/setxd60s",
        tablesCount: 6,
        tableLetters: ["A", "B", "C", "D", "E", "F"]
    },
    {
        id: "xdlive",
        label: "Xóc đĩa Live (1 Sảnh)",
        path: "/admin/setxdlive",
        tablesCount: 1,
        tableLetters: ["A"]
    },
    {
        id: "xdblockchain60s",
        label: "Xóc đĩa Blockchain 60s (2 Bàn)",
        path: "/admin/setxdblockchain60s",
        tablesCount: 2,
        tableLetters: ["A", "B"]
    }
];

export default function XocDiaHeaderNav({ currentMode, currentSanh = 1 }) {
    const navigate = useNavigate();
    const activeModeObj = GAME_MODES.find(m => m.id === currentMode) || GAME_MODES[0];
    const sanhNum = Number(currentSanh) || 1;

    return (
        <Box 
            className="classic-game-room-tabs" 
            sx={{ 
                mb: 2.5, 
                p: 1.5, 
                bgcolor: "#ffffff", 
                border: "1px solid #e2e8f0", 
                borderRadius: "12px", 
                display: "flex !important", 
                flexDirection: "column !important", 
                gap: 1.2,
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
            }}
        >
            {/* Hàng 1: Chọn thể loại Xóc đĩa */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Typography sx={{ fontSize: 13, color: "#64748b", fontWeight: 600, minWidth: 70 }}>
                    Thể loại:
                </Typography>
                {GAME_MODES.map((mode) => {
                    const isActive = mode.id === currentMode;
                    return (
                        <Button
                            key={mode.id}
                            size="small"
                            variant={isActive ? "contained" : "outlined"}
                            onClick={() => navigate(`${mode.path}?sanh=1`)}
                            sx={{
                                borderRadius: "6px",
                                textTransform: "none",
                                fontSize: "13px",
                                fontWeight: isActive ? 600 : 400,
                                bgcolor: isActive ? "#2563eb !important" : "#ffffff !important",
                                color: isActive ? "#ffffff !important" : "#475569 !important",
                                borderColor: isActive ? "#2563eb !important" : "#cbd5e1 !important"
                            }}
                        >
                            {mode.label}
                        </Button>
                    );
                })}
            </Box>

            {/* Hàng 2: Chọn bàn / sảnh của thể loại hiện tại */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", pt: 1, borderTop: "1px dashed #e2e8f0" }}>
                <Typography sx={{ fontSize: 13, color: "#64748b", fontWeight: 600, minWidth: 70 }}>
                    Chọn bàn:
                </Typography>
                {Array.from({ length: activeModeObj.tablesCount }, (_, i) => i + 1).map((tableId) => {
                    const letter = activeModeObj.tableLetters[tableId - 1] || tableId;
                    const isActive = tableId === sanhNum;
                    return (
                        <Button
                            key={tableId}
                            size="small"
                            variant={isActive ? "contained" : "outlined"}
                            onClick={() => navigate(`${activeModeObj.path}?sanh=${tableId}`)}
                            sx={{
                                borderRadius: "6px",
                                fontWeight: isActive ? 600 : 400,
                                fontSize: "13px",
                                textTransform: "none",
                                bgcolor: isActive ? "#059669 !important" : "#ffffff !important",
                                borderColor: isActive ? "#059669 !important" : "#cbd5e1 !important",
                                color: isActive ? "#ffffff !important" : "#334155 !important",
                                minWidth: "75px"
                            }}
                        >
                            Bàn {letter}
                        </Button>
                    );
                })}
            </Box>
        </Box>
    );
}
